import React from "react";
import { Box, Text } from "@chakra-ui/react";

export const NewsMessage = ({ message }) => {
  if (!message) return null;

  return (
    <Box bg="#DBDAF5" borderRadius="4px" p={3} m={3}>
      <Text
        fontSize="12px"
        fontWeight="84"
        lineHeight="1.5"
        letterSpacing="-1%"
        color="#14002E"
        fontFamily="Geist, sans-serif"
      >
        {message}
      </Text>
    </Box>
  );
};
